export const iconFontAwesomeLogisticsBridgeWater = (
	<i className="fa-solid fa-bridge-water"></i>
);
